import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import {
  faBriefcase,
  faChartSimple,
  faLayerGroup,
  faSackDollar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header from "../../Common/Header";
import JobCard from "./JobCard";
import "./ApppliedJobsExpanded.scss";
import useApppliedJobsExpanded from "./useApppliedJobsExpanded";
import { dateDiff } from "../../../_helpers/dateFormatter";
import { Pagination } from "antd";
import Footer from "../../Common/Footer/Footer";
import { definedColors, definedTextColors } from "../../../_helpers/colors";
import MainLayout from "../../Common/MainLayout";

function ApppliedJobsExpanded(props) {
  const {
    allJobs,
    loading,
    jobDetails,
    jobDetailsLoading,
    currentPage,
    assignedInterviewKit,
    jobCardDivParentRef,

    onCurrentJobCardChange,
    onCurrentPageChange,
    onTakeInterviewClick,
    onScheduleLinkClick,
    onViewJobOfferClick,
    onViewCompany,
  } = useApppliedJobsExpanded();

  return (
    <MainLayout pageName={"Applied Jobs"}>
      <Container className="job-board-expanded-wrapper">
        <div className="pb-4 job-board-expanded-applied footer-gap">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Row>
              <Col lg={5} xl={4} className="mt-3 mt-lg-0">
                <h2 className="d-inline-block pb-3">
                  Showing {allJobs?.count} Jobs
                </h2>
                <div className="job-cards-list" ref={jobCardDivParentRef}>
                  {allJobs?.results &&
                    Array.isArray(allJobs?.results) &&
                    allJobs.results.map((item, index) => (
                      <JobCard
                        jobDetail={item}
                        onJobCardClick={onCurrentJobCardChange}
                        activeJobCard={jobDetails.id === item.id}
                        jobCardDivParentRef={jobCardDivParentRef}
                      />
                    ))}
                </div>
                <Pagination
                  pageSize={10}
                  current={currentPage}
                  total={allJobs?.count}
                  onChange={onCurrentPageChange}
                  style={{ bottom: "0px", textAlign: "center", marginTop: 20 }}
                />
              </Col>
              <Col lg={7} xl={8} className="mt-lg-5 mt-3">
                {jobDetailsLoading ? (
                  <div className="d-flex justify-content-center align-items-start w-100">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <div className="job-expanded-info bg-white border p-4 border-radius-10">
                    {jobDetails?.job_details && (
                      <div className="bottom">
                        <div className="job-meta d-flex justify-content-between align-items-start mb-4">
                          <div className="text-right ml-auto">
                            <span
                              className={`px-3 py-1 d-inline-block text-capitalize`}
                              style={{
                                borderRadius: "100px",
                                background:
                                  definedColors[jobDetails?.interview_stage],
                                color:
                                  definedTextColors[
                                  jobDetails?.interview_stage
                                  ],
                              }}
                            >
                              {jobDetails?.interview_stage}
                            </span>

                            <div className="right my-3">
                              {assignedInterviewKit?.interview_kit && (
                                <p
                                  className="h5 mt-1 mb-0 cursor-pointer text-primary btn btn-primary"
                                  onClick={() => onTakeInterviewClick()}
                                >
                                  Take Interview:{" "}
                                  <span className="text-capitalize">
                                    {assignedInterviewKit?.interview_kit_detail &&
                                      assignedInterviewKit.interview_kit_detail
                                        ?.title}
                                  </span>
                                </p>
                              )}
                              {jobDetails?.interview_stage === "interview" &&
                                jobDetails?.schedule_link && (
                                  <p
                                    className="h5 mt-1 mb-0 cursor-pointer text-primary btn btn-primary"
                                    onClick={() => onScheduleLinkClick()}
                                  >
                                    Schedule Interview
                                  </p>
                                )}
                              {jobDetails?.interview_stage === "offer" &&
                                jobDetails?.is_job_offered === true &&
                                jobDetails?.job_offer_accepted === false && (
                                  <p
                                    className="h5 mt-1 mb-0 cursor-pointer text-primary btn btn-primary"
                                    onClick={() => onViewJobOfferClick()}
                                  >
                                    View Job Offer
                                  </p>
                                )}
                              {jobDetails?.interview_stage === "offer" &&
                                jobDetails?.is_job_offered === true &&
                                jobDetails?.job_offer_accepted === true && (
                                  <p className="h5 mt-1 mb-0 cursor-pointer text-primary btn btn-outline-primary ml-2">
                                    Job Offer Accepted
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>

                        <div className="job-meta">
                          <div className="skills d-flex flex-wrap my-2">
                            {Array.isArray(jobDetails?.job_details && jobDetails.job_details?.skill_names) &&
                              jobDetails?.job_details && jobDetails.job_details?.skill_names &&
                              jobDetails.job_details.skill_names.length > 0 && (
                                <>
                                  <p className="font-weight-medium w-100">Key Skills</p>
                                  {Array.isArray(jobDetails?.job_details && jobDetails.job_details?.skill_names) &&
                                    jobDetails?.job_details && jobDetails.job_details?.skill_names &&
                                    jobDetails.job_details.skill_names.map((skill) => (
                                      <span className="skill text-dark bg-grey-4 text-nowrap border px-2 rounded-lg text-capitalize mr-2 mb-2">
                                        {skill}
                                      </span>
                                    ))}
                                  <p className="text-muted d-inline-block">
                                    {Array.isArray(jobDetails?.job_details && jobDetails.job_details?.skill_names) &&
                                      jobDetails?.job_details && jobDetails.job_details?.skill_names &&
                                      jobDetails.job_details.skill_names.length > 6
                                      ? "..."
                                      : null}
                                  </p>
                                </>
                              )}
                          </div>
                          <div className="mb-3">
                            <p className="font-weight-medium">Job Description</p>
                            <div
                              className="text-grey-4"
                              dangerouslySetInnerHTML={{
                                __html:
                                  jobDetails?.job_details &&
                                  jobDetails.job_details?.role_description,
                              }}
                            ></div>
                          </div>
                          <div className="mb-3">
                            <p className="font-weight-medium">Requirements</p>
                            <div
                              className="text-grey-4"
                              dangerouslySetInnerHTML={{
                                __html:
                                  jobDetails?.job_details &&
                                  jobDetails.job_details?.role_requirements,
                              }}
                            ></div>
                          </div>
                          <div className="mb-3">
                            <p className="font-weight-medium">Benefits</p>
                            <div
                              className="text-grey-4"
                              dangerouslySetInnerHTML={{
                                __html:
                                  jobDetails?.job_details &&
                                  jobDetails.job_details?.role_benefits,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </Col>
            </Row>
          )}
        </div>
      </Container>
    </MainLayout>
  );
}
export default ApppliedJobsExpanded;
